import { Snackbar, SnackbarContent, Stack, Typography } from '@mui/material';
import { BOTTOM_BAR_HEIGHT } from '/@/components/app-navbar/bottombar';
import { _ } from '/@/locale';
import { round, type SeasonResult } from '../utils';
import { Co2Balance } from './results-card';

interface ResultSnackbarProps {
    lastResult?: SeasonResult;
    open: boolean;
    onClose: () => void;
}

/** Mobile summary of the last campaign, shown while the results card may be off screen. */
export default function ResultSnackbar({ lastResult, open, onClose }: ResultSnackbarProps) {
    return (
        <Snackbar
            open={open && !!lastResult}
            // Keep it up while the user keeps typing yields; it hides on tap or after each new result.
            onClose={(_event, reason) => reason !== 'clickaway' && onClose()}
            onClick={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            // Above the app's bottom bar, which phones show.
            sx={{ bottom: { xs: `calc(${BOTTOM_BAR_HEIGHT} + 8px)`, sm: 24 } }}
        >
            <SnackbarContent
                sx={{ backgroundColor: 'background.paper', color: 'primary.main', width: '100%' }}
                message={
                    lastResult && (
                        <Stack direction='row' spacing={3}>
                            <Stack>
                                <Typography variant='caption'>{_('Carbono orgánico en el suelo (SIM)')}</Typography>
                                <Typography variant='h6'>{round(lastResult.co.simulated, 2)}</Typography>
                            </Stack>
                            <Stack>
                                <Typography variant='caption'>{_('CO2 Fijado')}</Typography>
                                <Typography variant='h6'>
                                    <Co2Balance value={lastResult.co.fixed} />
                                </Typography>
                            </Stack>
                        </Stack>
                    )
                }
            />
        </Snackbar>
    );
}
